import { DecisionWithQualityType } from "../../types/commonTypes/decisionWithQualityType";

export const decisionWithQualityState : DecisionWithQualityType = {
    decisionNature: "",
    decisionQuality: "",
    decisionDate: "",
    effectiveDate: ""
}

export const decisionWithQualityAndEffictiveDateState : DecisionWithQualityType = {
    decisionNature: "",
    decisionQuality: "",
    decisionDate: "",
    effectiveDate: ""
}